import React from "react"
import Spinners from "components/Shared/Spinners"
import { useEffect } from "react"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import {
  Badge,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Row,
  Table,
} from "reactstrap"
import { getModifierDetail } from "store/actions/modiferAction"
import BackButton from "components/Shared/BackButton"
import { useTranslation } from "react-i18next"
import placeholderImage from "assets/images/placeholderImage.png"
import { formatImageTypeLabel } from "utils/displayLabels"
import { getCurrencyLabelByCountryCode } from "utils/currency"

const ModifierOptionDetails = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t("Modifier Details ")

  const location = useLocation()
  const dispatch = useDispatch()
  const searchParams = new URLSearchParams(location.search)
  const id = searchParams.get("id")

  const { loading, modifierDetails } = useSelector(state => state.Modifiers)

  useEffect(() => {
    getOldValues()
  }, [])

  const getOldValues = () => {
    const payload = {
      id,
    }
    dispatch(getModifierDetail(payload))
  }

  if (loading) return <Spinners />

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* <Breadcrumbs /> */}
          <Row>
            <Col lg={8}>
              <Card>
                <CardBody>
                  <CardTitle className="d-flex align-items-center">
                    <BackButton />
                    {t("Modifier Details")}
                  </CardTitle>
                  <div className="table-responsive">
                    {Object.values(modifierDetails).length === 0 ? (
                      <p className="text-center">
                        {t("No modifier details found")}
                      </p>
                    ) : (
                      <Table className="table-nowrap mb-0">
                        <tbody>
                          <tr>
                            <th scope="row">{t("Id")}</th>
                            <td>{modifierDetails._id}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Name(English)")}</th>
                            <td>{modifierDetails.name || "-"}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Name(عربي)")}</th>
                            <td>{modifierDetails.nameAr || "-"}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Status")}</th>
                            <td>
                              {modifierDetails.status === 1 ? (
                                <Badge className="bg-success">
                                  {t("Active")}
                                </Badge>
                              ) : (
                                <Badge className="bg-danger">
                                  {t("Deactive")}
                                </Badge>
                              )}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Image Type")}</th>
                            <td>
                              {formatImageTypeLabel(modifierDetails.imageUrlType)}
                            </td>
                          </tr>
                          {/* <tr>
                            <th scope="row">Image URL</th>
                            <td>
                              <p style={{ maxWidth: "40%" }}>
                                {modifierDetails.imageUrl || "-"}
                              </p>
                            </td>
                          </tr> */}
                          <tr>
                            <th scope="row">{t("Display Order")}</th>
                            <td>
                              {modifierDetails.displayOrder !== undefined
                                ? modifierDetails.displayOrder
                                : "-"}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Price")}</th>
                            <td>
                              {modifierDetails.price !== undefined
                                ? modifierDetails.price
                                : "-"}{" "}
                              {getCurrencyLabelByCountryCode(
                                modifierDetails.countryCode
                              )}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Minimum")}</th>
                            <td>
                              {modifierDetails.minimum !== undefined
                                ? modifierDetails.minimum
                                : "-"}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Maximum")}</th>
                            <td>
                              {modifierDetails.maximum !== undefined
                                ? modifierDetails.maximum
                                : "-"}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Calorie Count")}</th>
                            <td>
                              {modifierDetails.calorieCount !== undefined
                                ? modifierDetails.calorieCount
                                : "-"}
                            </td>
                          </tr>
                          {modifierDetails.sizeType !== 0 &&
                            modifierDetails.sizeType && (
                              <tr>
                                <th scope="row">{t("Size Type")}</th>
                                <td>
                                  {modifierDetails.sizeType === 1 && t("Small")}
                                  {modifierDetails.sizeType === 2 &&
                                    t("Regular")}
                                  {modifierDetails.sizeType === 3 && t("Large")}
                                  {modifierDetails.sizeType === 4 &&
                                    t("Extra Large")}
                                </td>
                              </tr>
                            )}
                          {/* <tr>
                            <th scope="row">{t("Disabled Branches")}</th>
                            <td>
                              {modifierDetails?.disabledBranches?.length ===
                              0 ? (
                                "-"
                              ) : (
                                <div>
                                  {modifierDetails?.disabledBranches?.map(
                                    item => (
                                      <span key={item._id} className="px-1">
                                        {language === "sa"
                                          ? item.nameAr
                                          : item.name}
                                        ,
                                      </span>
                                    )
                                  )}
                                </div>
                              )}
                            </td>
                          </tr> */}
                        </tbody>
                      </Table>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col lg={4}>
              <Card className="card_100_24">
                <CardBody>
                  {/* <CardTitle>Modifier Image</CardTitle> */}
                  <img
                    src={
                      modifierDetails.imageUrl
                        ? modifierDetails.imageUrl
                        : placeholderImage
                    }
                    alt=""
                    className="img-fluid d-block mx-auto"
                    style={{ height: "100%", objectFit: "contain" }}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ModifierOptionDetails
